/* eslint-disable no-alert */
import React from 'react';
import { Alert, Button, Spinner } from 'reactstrap';
import useImpersonation from '../hooks/useImpersonation';

function ImpersonationBanner() {
  const {
    isImpersonating, impersonationDetails, loading, stopImpersonation,
  } = useImpersonation();

  if (!isImpersonating || !impersonationDetails) {
    return null;
  }
  const handleStopImpersonation = async () => {
    if (window.confirm('Are you sure you want to stop impersonating? You will be signed out.')) {
      await stopImpersonation();
    }
  };

  return (
    <Alert
      color="danger"
      className="mb-0"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        borderRadius: 0,
        borderLeft: '5px solid #ff6b6b',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <i className="fas fa-user-secret fa-lg mr-3 text-danger" />
          <div>
            <strong className="d-block">
              <i className="fas fa-exclamation-triangle mr-2" />
              IMPERSONATION MODE ACTIVE
            </strong>
            <small className="d-block mt-1">
              You (
              {impersonationDetails.adminName}
              ) are impersonating
              {' '}
              <strong>{impersonationDetails.targetName || 'Unknown User'}</strong>
            </small>
          </div>
        </div>
        <Button
          color="white"
          size="sm"
          onClick={handleStopImpersonation}
          disabled={loading}
          className="d-flex align-items-center"
        >
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Stopping...
            </>
          ) : (
            <>
              <i className="fas fa-sign-out-alt mr-2" />
              Stop Impersonation
            </>
          )}
        </Button>
      </div>
    </Alert>
  );
}

export default ImpersonationBanner;
